import { render, staticRenderFns } from "./InvoiceReceiptListPage.vue?vue&type=template&id=76e76536&scoped=true&"
import script from "./InvoiceReceiptListPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiptListPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceiptListPage.vue?vue&type=style&index=0&id=76e76536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e76536",
  null
  
)

export default component.exports